import { Loader } from "@mantine/core";
import useColors from "../../../theme/useColors";

interface PollingRefreshIndicatorProps {
  visible?: boolean;
}

const PollingRefreshIndicator: React.FC<PollingRefreshIndicatorProps> = ({
  visible = false,
}) => {
  const colors = useColors();

  if (!visible) {
    return null;
  }

  return (
    <Loader
      size='xs'
      color={colors.primary[5]}
      aria-label='Refreshing data'
      style={{ flexShrink: 0 }}
    />
  );
};

export default PollingRefreshIndicator;
